import { Link } from "react-router-dom";

/**
 * Shared shell for auth screens (login / register / forgot / reset).
 * Puts the crest logo up top, wraps the form in a warm card, and adds a
 * subtle textured background so these pages feel like brand touchpoints
 * rather than plain forms.
 */
export default function AuthShell({ eyebrow, title, subtitle, children, footer }) {
  return (
    <div
      className="min-h-[calc(100vh-88px)] flex items-start sm:items-center justify-center px-5 py-10"
      style={{
        background:
          "radial-gradient(1200px 500px at 15% -10%, rgba(31,93,52,0.08), transparent 65%)," +
          "radial-gradient(900px 500px at 90% 110%, rgba(201,162,75,0.10), transparent 60%)," +
          "var(--bone)",
      }}
    >
      <div className="w-full max-w-md">
        <Link to="/" data-testid="auth-brand-link" className="block text-center mb-8">
          <img
            src="/brand/addvendtour-thumbnail.png"
            alt="AddVendTour"
            className="h-32 w-32 sm:h-40 sm:w-40 mx-auto object-contain drop-shadow-lg rounded-3xl"
          />
          <div
            className="mt-3 text-sm"
            style={{ color: "var(--avt-purple)" }}
          >
            <span style={{ color: "var(--avt-teal)" }}>Add your event.</span>{" "}
            <span style={{ color: "var(--avt-pink)" }}>Book vendors.</span>{" "}
            <span style={{ color: "var(--avt-lime)" }}>Discover more.</span>
          </div>
        </Link>

        <div
          className="rounded-2xl border p-8 sm:p-10"
          style={{
            backgroundColor: "#fff",
            borderColor: "rgba(0,0,0,0.06)",
            boxShadow: "0 30px 80px -40px rgba(21,65,35,0.35), 0 6px 24px -8px rgba(0,0,0,0.06)",
          }}
        >
          {eyebrow && (
            <div className="overline" style={{ color: "var(--terracotta)" }}>{eyebrow}</div>
          )}
          <h1 className="font-serif text-4xl mt-2 leading-tight">{title}</h1>
          {subtitle && (
            <div className="mt-3 text-sm" style={{ color: "var(--ink-soft)" }}>
              {subtitle}
            </div>
          )}
          <div className="mt-8">{children}</div>
        </div>

        {footer && (
          <div className="mt-6 text-center text-xs" style={{ color: "var(--ink-soft)" }}>
            {footer}
          </div>
        )}
      </div>
    </div>
  );
}
